import { createAction, props } from '@ngrx/store'
import { ActivityAPIModel, ModuleDashboardAPIModel, PaginatedAPI } from 'src/app/models/api.model'

const actionDashboardPrefix = '[activity-dashboard]'

export const fetch_activity_dashboard_data = createAction(
  `${actionDashboardPrefix} fetch_activity_dashboard_data`,
  props<{ days: number; sortBy: string; sortOrder: string }>()
)
export const fetch_activity_dashboard_data_success = createAction(
  `${actionDashboardPrefix} fetch_activity_dashboard_data_success`,
  props<ModuleDashboardAPIModel>()
)

export const save_activity_action = createAction(
  `${actionDashboardPrefix} save_activity_action`,
  props<{ activity: ActivityAPIModel; files: FileList; routeTo: string }>()
)

export const save_activity_success_action = createAction(
  `${actionDashboardPrefix} save_activity_success_action`,
  props<{ activity: ActivityAPIModel; routeTo: string }>()
)

export const FETCH_ACTIVITY_DETAILS = createAction(
  `${actionDashboardPrefix} fetch_activity_details`,
  props<{ id: string }>()
)

export const FETCH_ACTIVITY_DETAILS_SUCCESS = createAction(
  `${actionDashboardPrefix} fetch_activity_details_success`,
  props<{ activity: ActivityAPIModel }>()
)

export const UPDATE_ACTIVITY_ACTION = createAction(
  `${actionDashboardPrefix} update_activity_action`,
  props<{ activity: Partial<ActivityAPIModel>; id: string; files: File[]; routeTo: string }>()
)

export const UPDATE_ACTIVITY_SUCCESS_ACTION = createAction(
  `${actionDashboardPrefix} update_activity_success_action`,
  props<{ activity: Partial<ActivityAPIModel>; routeTo: string }>()
)

export const DELETE_ACTIVITY_DETAILS = createAction(`${actionDashboardPrefix} DELETE_ACTIVITY_DETAILS`)

export const LOAD_ACTIVITY_SUMMARY_DETAILS = createAction(
  `${actionDashboardPrefix} load_activity_summary_details`,
  props<{
    queryParams: {
      key: string
      value: string
    }[]
    searchRequestBody: any
  }>()
)

export const LOAD_ACTIVITY_SUMMARY_DETAILS_SUCCESS = createAction(
  `${actionDashboardPrefix} load_activity_summary_details_success`,
  props<PaginatedAPI<ActivityAPIModel>>()
)
